module.exports = __webpack_public_path__ + "img/Venom.497ee1f2.png";